import React, { lazy, Suspense } from "react";
export default function dynamic(loader: any, opts: any = {}) {
  const Comp = lazy(loader);
  const Loading = opts.loading || (() => null);
  return function DynamicComp(props: any) {
    return (
      <Suspense fallback={<Loading />}>
        <Comp {...props} />
      </Suspense>
    );
  };
}
